import { Component, OnInit, Injector, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericBasicGUI } from 'src/model/class/component classes/generic-basic-gui';
import { AppSettings } from 'src/components/shared-components/class/general-classes/app-settings';

@Component({
    selector: 'app-application-button',
    templateUrl: './application-button.component.html',
    styleUrls: ['./application-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplicationButtonComponent extends GenericBasicGUI implements OnInit {
  private timeoutMousDown: ReturnType<typeof setTimeout>;

  public styles =
    {
      'font-family': 'Arial',
      // tslint:disable-next-line: object-literal-key-quotes
      'color': '#000000',
      'font-size': '15px',
      'font-style': 'normal', // italic
      'font-weight': 'normal', // bol
      'font-decorator': 'none', // underline
      'background-image': '',
      'overflow': 'hidden'
    };

  public stylesChild = {
  };

  /**
   * Giorgia -
   * @param injector The injector param is used by the parent classes to inject the services that they needed:
   * using this trick if the parent classes needed some specific service I don't need to inject them here
   * but I can do the injection in the specific class.
   */
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    [this.styles, this.stylesChild] = super.HandleProperties(this.styles, this.stylesChild);

    this.styles["margin"] = '0 auto';
  }

  ngOnDestroy() {
    this.onDestroyChildren();
  }

  protected setCurrentImage(urlImage: string, stretch: boolean) {
    if (!this.ShowingInDesktopVersion) {
      this.styles["width"] = '48px';
      this.styles["height"] = '48px';
      this.styles['background-size'] = 'cover';
    }

    if (urlImage !== "") {
      this.styles["background-image"] = "url(" + urlImage + ")";

      if (stretch) {
        this.styles["background-size"] = "contain";
      } else {
        this.styles["background-size"] = "initial";
      }

      this.styles["background-position"] = 'center';
      this.styles["background-repeat"] = 'no-repeat';
    }
    else {
      this.styles["background"] = AppSettings.CUSTOM_INTERFACE_BUTTON_DEFAULT_BACKGROUND;
      this.styles["border"] = AppSettings.CUSTOM_INTERFACE_BUTTON_DEFAULT_BORDER;
    }
  }


  //ATTENTION !!! 
  //Quando si vorrà sviluppare questo componente, bisognerà considerare:
  //La necessità di abilitare i listener  MouseDown/MouseUp SOLO SU browser e TouchStart/TouchEnd SOLO SU Android/iOS.
  //Assicurarsi (eventualmente) che i comandi associati al button non siano dati senza volerlo mentre si scrolla la pagina.
  //
  //Per la soluzione ad entrabi questi punti, si osservi quanto fatto nella classe "COmmand-button.ts". 
  public MouseDown() {
    this.SetPressedImage(true);
  }


  //ATTENTION !!! 
  //Quando si vorrà sviluppare questo componente, bisognerà considerare:
  //La necessità di abilitare i listener  MouseDown/MouseUp SOLO SU browser e TouchStart/TouchEnd SOLO SU Android/iOS.
  //Assicurarsi (eventualmente) che i comandi associati al button non siano dati senza volerlo mentre si scrolla la pagina.
  //
  //Per la soluzione ad entrabi questi punti, si osservi quanto fatto nella classe "COmmand-button.ts". 
  public MouseUp() {
    clearTimeout(this.timeoutMousDown);

    this.SetPressedImage(false);
  }


  //ATTENTION !!! 
  //Quando si vorrà sviluppare questo componente, bisognerà considerare:
  //La necessità di abilitare i listener  MouseDown/MouseUp SOLO SU browser e TouchStart/TouchEnd SOLO SU Android/iOS.
  //Assicurarsi (eventualmente) che i comandi associati al button non siano dati senza volerlo mentre si scrolla la pagina.
  //
  //Per la soluzione ad entrabi questi punti, si osservi quanto fatto nella classe "COmmand-button.ts". 
  /** GF: handle the touch from device
   * if the button is keep pressed (not just a rapid touch), the event MouseUp and Click is not sended.
   * For this reason if the image is keep pressed after 500 ms is simulated the mouseUp event and sended the click event
   */
  public TouchStart() {
    this.SetPressedImage(true);
    this.timeoutMousDown = setTimeout(() => {
      this.SetPressedImage(false);
      this.Click();
    }, 500);
  }


  //ATTENTION !!! 
  //Quando si vorrà sviluppare questo componente, bisognerà considerare:
  //La necessità di abilitare i listener  MouseDown/MouseUp SOLO SU browser e TouchStart/TouchEnd SOLO SU Android/iOS.
  //Assicurarsi (eventualmente) che i comandi associati al button non siano dati senza volerlo mentre si scrolla la pagina.
  //
  //Per la soluzione ad entrabi questi punti, si osservi quanto fatto nella classe "COmmand-button.ts". 
  public TouchEnd() {
    //...
  }


  //ATTENTION !!! 
  //Quando si vorrà sviluppare questo componente, bisognerà considerare:
  //La necessità di abilitare i listener  MouseDown/MouseUp SOLO SU browser e TouchStart/TouchEnd SOLO SU Android/iOS.
  //Assicurarsi (eventualmente) che i comandi associati al button non siano dati senza volerlo mentre si scrolla la pagina.
  //
  //Per la soluzione ad entrabi questi punti, si osservi quanto fatto nella classe "COmmand-button.ts". 
  public Click() {
    //todo open application
  }

}
